export const UNDERGROUND = -1
export const GROUND = 0
export const HEADER = 100
export const DROPDOWN = 200
export const ALERT = 300
export const MODAL = 400
export const TOPMOST = 70000
